import { render, staticRenderFns } from "./GroupCategoryType.vue?vue&type=template&id=d4574a2e&"
import script from "./GroupCategoryType.vue?vue&type=script&lang=js&"
export * from "./GroupCategoryType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports